import { render, staticRenderFns } from "./myReportButton.vue?vue&type=template&id=83c6c83c&scoped=true&"
import script from "./myReportButton.vue?vue&type=script&lang=ts&"
export * from "./myReportButton.vue?vue&type=script&lang=ts&"
import style0 from "./myReportButton.vue?vue&type=style&index=0&id=83c6c83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c6c83c",
  null
  
)

export default component.exports